<template>
  <a-flex :gap="16" justify="space-between" style="margin: 16px">
    <main-template-seg-view style="margin-bottom: 66px"/>
    <a-flex vertical style="width: 420px; flex: 0 0 420px" gap="middle">
      <main-v-i-p-seg-view/>
      <main-wechat-merchant-seg-view v-if="ua.wechatMerchant.needShowEnter()"/>
      <main-activities-seg-view/>
      <main-draft-seg-view/>
      <main-footprint-seg-view/>
    </a-flex>
  </a-flex>
</template>

<script setup lang="ts">

import MainTemplateSegView from "@/views/main/segments/MainTemplateSegView.vue";
import MainVIPSegView from "@/views/main/segments/MainVIPSegView.vue";
import MainWechatMerchantSegView from "@/views/main/segments/MainWechatMerchantSegView.vue";
import MainActivitiesSegView from "@/views/main/segments/MainActivitiesSegView.vue";
import MainDraftSegView from "@/views/main/segments/MainDraftSegView.vue";
import MainFootprintSegView from "@/views/main/segments/MainFootprintSegView.vue";
import {useRoute} from "vue-router";
import {UserAgent} from "@/model/user_agent";


const route = useRoute()
const ua = route.meta.agent as UserAgent
</script>

<style scoped lang="sass">

</style>